import {
  physicalRoofPlane,
  roofDistancePerGroundRowM,
} from '@payaca/helpers/solarMounting';
import {
  fixedSolarRowGap,
  solarPanelGaps,
  type SolarPlacementRules,
} from '@payaca/helpers/solarPlacementRules';
import { type WorkingFace } from './types';

/** Drag uses applied mounting/spacing; pending edits and ring order are not axes. */
export const appliedArraySnap = (
  face: WorkingFace,
  offsetDegrees: number,
  pendingRules: SolarPlacementRules
) => {
  const rules = face.appliedPlacementRules ?? pendingRules;
  const gaps = solarPanelGaps(rules);
  // Null deliberately disables snapping; undefined retains the legacy
  // directionless equal-gap path for layouts outside reference mode.
  let arrayAzimuthDegrees: number | null | undefined =
    face.appliedArrayAzimuthDegrees;
  if (
    arrayAzimuthDegrees === undefined &&
    (face.roofEdgeAnchor || face.appliedRoofEdgeAnchor)
  )
    arrayAzimuthDegrees = null;
  if (
    face.appliedArrayAzimuthDegrees === undefined &&
    !face.roofEdgeAnchor &&
    !face.appliedRoofEdgeAnchor &&
    face.arrayAzimuthDegrees != null &&
    (face.appliedMounting === 'tilt' ||
      (face.appliedMounting === 'flush' && face.roofPlane))
  )
    arrayAzimuthDegrees = face.arrayAzimuthDegrees + offsetDegrees;
  if (
    face.appliedPlacementRules &&
    face.appliedMounting === 'tilt' &&
    rules.flatRoof.rowSpacingMode === 'fixed' &&
    !face.roofPlane
  )
    arrayAzimuthDegrees = null;
  // Only a completed pack applies fixed intent. Tilt snaps in plan metres,
  // so convert the physical roof distance using the applied array-row bearing.
  if (
    face.appliedPlacementRules &&
    face.appliedMounting === 'tilt' &&
    rules.flatRoof.rowSpacingMode === 'fixed' &&
    face.roofPlane &&
    arrayAzimuthDegrees != null
  )
    gaps.rowGapM =
      fixedSolarRowGap(rules.flatRoof, gaps.rowGapM, true) /
      roofDistancePerGroundRowM(face.roofPlane, arrayAzimuthDegrees);
  return {
    ...gaps,
    arrayAzimuthDegrees,
    roofPlane:
      face.appliedMounting === 'flush' ? physicalRoofPlane(face) : undefined,
  };
};
